module.exports = __webpack_public_path__ + "img/koken.a5e9bc0d.jpg";